import { Map } from '@opengov/compose-app/immutable';
import { IStory } from '@opengov/stories-shared/types';
import { ESelectAllStatus, IStoriesFolder } from '../../../../types/storyListTypes';
import { getDisplayNameForNodeId } from '@opengov/component-library/capital';

export const getFolderName = (
  isViewingFolder: boolean,
  isTemplate: boolean,
  story: IStory,
  folderStructure: IStoriesFolder[]
): string | null => {
  return !isViewingFolder && !isTemplate ? getDisplayNameForNodeId(story.folderId, folderStructure) : null;
};

export const getPublicationName = (publications: { id: string; title: string }[], story: IStory): string | null => {
  const pubId = story.folder?.publicationId;
  if (pubId && publications?.length) {
    const publication = publications.find((pub) => pub.id === pubId);
    return publication?.title;
  }
  return null;
};

export const handleStorySelection = (
  currentStory: IStory,
  totalStoriesCount: number,
  selectedStories: Map<string, IStory>,
  setSelectedStories,
  setSelectAllStatus
) => {
  let updatedSelectedStories;

  if (selectedStories.has(currentStory._id)) {
    updatedSelectedStories = selectedStories.delete(currentStory._id);
  } else {
    updatedSelectedStories = selectedStories.set(currentStory._id, currentStory);
  }
  setSelectedStories(updatedSelectedStories);
  if (updatedSelectedStories.size === totalStoriesCount) {
    setSelectAllStatus(ESelectAllStatus.All);
  } else if (updatedSelectedStories.size === 0) {
    setSelectAllStatus(ESelectAllStatus.None);
  } else {
    setSelectAllStatus(ESelectAllStatus.Mixed);
  }
};

export const handleRowOnSelectAll = (
  allStories: Map<string, IStory>,
  setSelectedStories,
  selectAllStatus: ESelectAllStatus,
  setSelectAllStatus
) => {
  if (selectAllStatus === ESelectAllStatus.None || selectAllStatus === ESelectAllStatus.Mixed) {
    setSelectedStories(allStories);
    setSelectAllStatus(ESelectAllStatus.All);
  } else {
    setSelectAllStatus(ESelectAllStatus.None);
    setSelectedStories(Map([]));
  }
};
